(() => {
  const STORAGE_KEY = 'lineaWishlistV1';
  const buttonSelector = '[data-linea-wishlist-button]';
  const openSelector = '[data-linea-wishlist-open]';
  const closeSelector = '[data-linea-wishlist-close]';

  const readItems = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.id) : [];
    } catch (_error) {
      return [];
    }
  };

  const writeItems = (items) => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  };

  const getItemFromButton = (button) => ({
    id: String(button.dataset.productId || ''),
    title: button.dataset.productTitle || '',
    url: button.dataset.productUrl || '#',
    image: button.dataset.productImage || '',
    price: button.dataset.productPrice || '',
  });

  const escapeHtml = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => {
      const entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
      return entities[char];
    });

  const safeUrl = (value) => {
    const url = String(value || '#');
    return url.startsWith('/') || url.startsWith('https://') || url.startsWith('http://') ? url : '#';
  };

  const syncButtons = () => {
    const items = readItems();
    const ids = new Set(items.map((item) => item.id));
    document.querySelectorAll(buttonSelector).forEach((button) => {
      const active = ids.has(String(button.dataset.productId || ''));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'お気に入りから削除' : 'お気に入りに追加');
    });

    document.querySelectorAll('[data-linea-wishlist-count]').forEach((count) => {
      const countValue = count.querySelector('[data-linea-wishlist-count-value]');
      if (countValue) {
        countValue.textContent = String(items.length);
      } else {
        count.textContent = String(items.length);
      }
      count.hidden = items.length === 0;
    });

    document.querySelectorAll(openSelector).forEach((button) => {
      button.classList.toggle('has-items', items.length > 0);
    });
  };

  const renderDrawer = () => {
    const container = document.querySelector('[data-linea-wishlist-items]');
    if (!container) return;

    const items = readItems();
    if (!items.length) {
      container.innerHTML = '<p class="linea-wishlist-empty">気になる商品をハートで保存できます。</p>';
      return;
    }

    container.innerHTML = items
      .map(
        (item) => {
          const id = escapeHtml(item.id);
          const title = escapeHtml(item.title);
          const url = safeUrl(item.url);
          const image = safeUrl(item.image);
          const price = escapeHtml(item.price);

          return `
          <article class="linea-wishlist-item" data-linea-wishlist-item="${id}">
            ${
              image && image !== '#'
                ? `<a href="${url}"><img class="linea-wishlist-item__image" src="${image}" alt="${title}" loading="lazy"></a>`
                : '<div class="linea-wishlist-item__image"></div>'
            }
            <div>
              <a class="linea-wishlist-item__title" href="${url}">${title}</a>
              ${price ? `<div class="linea-wishlist-item__price">${price}</div>` : ''}
            </div>
            <button type="button" class="linea-wishlist-item__remove" data-linea-wishlist-remove="${id}" aria-label="お気に入りから削除">×</button>
          </article>
        `;
        }
      )
      .join('');
  };

  const toggleItem = (button) => {
    const item = getItemFromButton(button);
    if (!item.id) return;

    const items = readItems();
    const existing = items.findIndex((saved) => saved.id === item.id);
    if (existing >= 0) {
      items.splice(existing, 1);
    } else {
      items.unshift(item);
    }

    writeItems(items);
    syncButtons();
    renderDrawer();
  };

  const openDrawer = () => {
    renderDrawer();
    const drawer = document.querySelector('[data-linea-wishlist-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('linea-wishlist-open');
  };

  const closeDrawer = () => {
    const drawer = document.querySelector('[data-linea-wishlist-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('linea-wishlist-open');
  };

  document.addEventListener('click', (event) => {
    const wishlistButton = event.target.closest(buttonSelector);
    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleItem(wishlistButton);
      return;
    }

    if (event.target.closest(openSelector)) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest(closeSelector)) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const removeButton = event.target.closest('[data-linea-wishlist-remove]');
    if (removeButton) {
      const id = String(removeButton.dataset.lineaWishlistRemove || '');
      writeItems(readItems().filter((item) => item.id !== id));
      syncButtons();
      renderDrawer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncButtons();
    renderDrawer();
  });

  document.addEventListener('shopify:section:load', () => {
    syncButtons();
    renderDrawer();
  });
})();
